import { rem } from 'polished';
import styled from '../../../styles/theme';
import ModalCarOptionDetailTemplate from './ModalCarOptionDetailTemplate';

export const ModalCarOptionDetailStyled = styled(ModalCarOptionDetailTemplate)`
    margin-top: -${rem(50)};
    width: 98%;

    .option-detail {
        &__category {
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
            text-transform: uppercase;
            display: inline-block;
        }

        &__title {
            text-transform: uppercase;
        }

        &__image {
            width: 100%;
            padding: ${rem(15)} 0;
        }

        &__description {
            ul {
                margin: 0;
                padding: 0;

                li {
                    list-style: none;
                    padding-bottom: ${rem(10)};
                }
            }
        }
    }
`;
